import React from 'react';
import './subject-selector.css';
import { IconButton } from '../../../components/icon-button';
import { Icon } from '../../../components/icon';

const SubjectSelector = props => {
    const {
        activeSubject,
        activeSubjectIndex,
        setActiveSubjectIndex,
        modalVisible,
    } = props;

    const nextSubject = () => {
        if (activeSubjectIndex === 6) {
            setActiveSubjectIndex(0);
        } else {
            setActiveSubjectIndex(activeSubjectIndex + 1);
        }
    };

    const previousSubject = () => {
        if (activeSubjectIndex === 0) {
            setActiveSubjectIndex(6);
        } else {
            setActiveSubjectIndex(activeSubjectIndex - 1);
        }
    };

    return (
        <div className="subject-selector">
            <IconButton
                onClick={() => previousSubject()}
                iconName="previous"
                size="small"
                isDisabled={modalVisible}
            />
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
            <div
                className="subject-selector__current-subject"
                tabIndex={!modalVisible ? 0 : null}
                aria-hidden={modalVisible}
            >
                <Icon
                    iconName={activeSubject}
                    type="png"
                    pressIcon
                    size="medium"
                />
            </div>
            <IconButton
                onClick={() => nextSubject()}
                iconName="next"
                size="small"
                isDisabled={modalVisible}
            />
        </div>
    );
};

export { SubjectSelector };
